import ApiRequest from "../utils/ApiRequest";

export default class Schedule {

    getAd = async () => {
        return await ApiRequest.set(`/v3/getAd`, "GET");
    }

}
